<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ pagetop</a>
    <div class="max">
      <nav>
        <ul>
          <li itemprop="name"><a itemprop="url" href="/">トップページ</a></li>
        <li itemprop="name"><a itemprop="url" href="/about/">お知らせ</a></li>
        <li itemprop="name"><a itemprop="url" href="/about/">取り扱いブランド</a></li>
        <li itemprop="name"><a itemprop="url" href="/about/">工賃表</a></li>
        </ul>
      </nav>
      <small class="copy">Copyright &copy; {{ currentYear }} komiy-cycle All rights reserved.</small>
    </div>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: module.$gray;
  padding: 0 0 4rem;
  position: relative;
  z-index: 2;
  .pagetop{
    background: module.$border;
    display: block;
    text-align: center;
    padding: 1rem 0;
  }
  nav{
    padding: 3.2rem module.side();
    ul{
      @include module.flex();
      align-items: center;
      justify-content: center;
      li{
        margin: 0 0 0 3.2rem;
        &:first-child{
          margin: 0;
        }
        a{
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
  }
  small{
    display: block;
    text-align: center;
    font-size: .72rem;
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>